import { CheckResponse } from "domain/entity/Home";
import HomeRepository from "domain/repository/Home";

export default class HomeUseCase implements HomeRepository {
    constructor(private repository: HomeRepository) { }

    getCheckVerified(): Promise<CheckResponse> {
        return this.repository.getCheckVerified()
    }
}